import { useState, useEffect, useCallback } from 'react'
import { authenticatedFetchJson } from '../services/api/apiClient'
import { apiEndpoints } from '../consts'

/**
 * Hook for fetching the count of pending Stripe setup requests.
 * @param {boolean} enabled - Whether to fetch (skip for non-admin users)
 */
const usePendingSetupCount = (enabled = true) => {
  const [count, setCount] = useState(0)

  const fetchCount = useCallback(async () => {
    if (!enabled) return
    try {
      const res = await authenticatedFetchJson(apiEndpoints.billingPendingSetupCount)
      setCount(res?.data?.count || 0)
    } catch {
      /* silent — badge is non-critical */
    }
  }, [enabled])

  useEffect(() => {
    fetchCount()
    if (!enabled) return
    const interval = setInterval(fetchCount, 30000)
    return () => clearInterval(interval)
  }, [fetchCount, enabled])

  return { count, refetch: fetchCount }
}

export default usePendingSetupCount
